module.exports = __webpack_public_path__ + "img/Gastronomy.5f878ee5.svg";